<div class="admin">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12" >
        <h2 class="txt txt--title">Crear solicitud nueva licencia</h2>
      </div>
      <div class="admin__actions col-12">
        <div class="row">
          <div class="col-12 col-lg-4" *ngIf="showThirdPersonRequest">
            <div class="admin__action" routerLink="./third">
              <h3>Nueva solicitud para un empleado o contratista*</h3>
            </div>
            <small class="note note--mobile">*Solo se puede solicitar para un empleado o contratista del mismo contrato
              o área.</small>
          </div>
          <div class="col-12 col-lg-4" *ngIf="showPersonalLicenseRequest">
            <div class="admin__action" routerLink="./personal" routerLinkActive="true">
              <h3>Nueva solicitud para mí</h3>
            </div>
          </div>
          <div class="col-12" *ngIf="showThirdPersonRequest">
            <p class="note note--desktop">*Solo se puede solicitar para un empleado o contratista del mismo contrato o
              área.</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
